(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 8273:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CountUp": function() { return /* binding */ CountUp; }
/* harmony export */ });
var __assign=undefined&&undefined.__assign||function(){return(__assign=Object.assign||function(t){for(var i,n=1,a=arguments.length;n<a;n++)for(var s in i=arguments[n])Object.prototype.hasOwnProperty.call(i,s)&&(t[s]=i[s]);return t}).apply(this,arguments)},CountUp=function(){function t(t,i,n){var a=this;this.endVal=i,this.options=n,this.version="2.2.0",this.defaults={startVal:0,decimalPlaces:0,duration:2,useEasing:!0,useGrouping:!0,smartEasingThreshold:999,smartEasingAmount:333,separator:",",decimal:".",prefix:"",suffix:"",enableScrollSpy:!1,scrollSpyDelay:200,scrollSpyOnce:!1},this.finalEndVal=null,this.useEasing=!0,this.countDown=!1,this.error="",this.startVal=0,this.paused=!0,this.once=!1,this.count=function(t){a.startTime||(a.startTime=t);var i=t-a.startTime;a.remaining=a.duration-i,a.useEasing?a.countDown?a.frameVal=a.startVal-a.easingFn(i,0,a.startVal-a.endVal,a.duration):a.frameVal=a.easingFn(i,a.startVal,a.endVal-a.startVal,a.duration):a.countDown?a.frameVal=a.startVal-(a.startVal-a.endVal)*(i/a.duration):a.frameVal=a.startVal+(a.endVal-a.startVal)*(i/a.duration),a.countDown?a.frameVal=a.frameVal<a.endVal?a.endVal:a.frameVal:a.frameVal=a.frameVal>a.endVal?a.endVal:a.frameVal,a.frameVal=Number(a.frameVal.toFixed(a.options.decimalPlaces)),a.printValue(a.frameVal),i<a.duration?a.rAF=requestAnimationFrame(a.count):null!==a.finalEndVal?a.update(a.finalEndVal):a.callback&&a.callback()},this.formatNumber=function(t){var i,n,s,e,r=t<0?"-":"";i=Math.abs(t).toFixed(a.options.decimalPlaces);var o=(i+="").split(".");if(n=o[0],s=o.length>1?a.options.decimal+o[1]:"",a.options.useGrouping){e="";for(var l=0,h=n.length;l<h;++l)0!==l&&l%3==0&&(e=a.options.separator+e),e=n[h-l-1]+e;n=e}return a.options.numerals&&a.options.numerals.length&&(n=n.replace(/[0-9]/g,function(t){return a.options.numerals[+t]}),s=s.replace(/[0-9]/g,function(t){return a.options.numerals[+t]})),r+a.options.prefix+n+s+a.options.suffix},this.easeOutExpo=function(t,i,n,a){return n*(1-Math.pow(2,-10*t/a))*1024/1023+i},this.options=__assign(__assign({},this.defaults),n),this.formattingFn=this.options.formattingFn?this.options.formattingFn:this.formatNumber,this.easingFn=this.options.easingFn?this.options.easingFn:this.easeOutExpo,this.startVal=this.validateValue(this.options.startVal),this.frameVal=this.startVal,this.endVal=this.validateValue(i),this.options.decimalPlaces=Math.max(this.options.decimalPlaces),this.resetDuration(),this.options.separator=String(this.options.separator),this.useEasing=this.options.useEasing,""===this.options.separator&&(this.options.useGrouping=!1),this.el="string"==typeof t?document.getElementById(t):t,this.el?this.printValue(this.startVal):this.error="[CountUp] target is null or undefined",void 0!==window&&this.options.enableScrollSpy&&(this.error?console.error(this.error,t):(window.onScrollFns=window.onScrollFns||[],window.onScrollFns.push(function(){return a.handleScroll(a)}),window.onscroll=function(){window.onScrollFns.forEach(function(t){return t()})},this.handleScroll(this)))}return t.prototype.handleScroll=function(t){if(t&&window&&!t.once){var i=window.innerHeight+window.scrollY,n=t.el.offsetTop+t.el.offsetHeight;n<i&&n>window.scrollY&&t.paused?(t.paused=!1,setTimeout(function(){return t.start()},t.options.scrollSpyDelay),t.options.scrollSpyOnce&&(t.once=!0)):window.scrollY>n&&!t.paused&&t.reset()}},t.prototype.determineDirectionAndSmartEasing=function(){var t=this.finalEndVal?this.finalEndVal:this.endVal;this.countDown=this.startVal>t;var i=t-this.startVal;if(Math.abs(i)>this.options.smartEasingThreshold){this.finalEndVal=t;var n=this.countDown?1:-1;this.endVal=t+n*this.options.smartEasingAmount,this.duration=this.duration/2}else this.endVal=t,this.finalEndVal=null;this.finalEndVal?this.useEasing=!1:this.useEasing=this.options.useEasing},t.prototype.start=function(t){this.error||(this.callback=t,this.duration>0?(this.determineDirectionAndSmartEasing(),this.paused=!1,this.rAF=requestAnimationFrame(this.count)):this.printValue(this.endVal))},t.prototype.pauseResume=function(){this.paused?(this.startTime=null,this.duration=this.remaining,this.startVal=this.frameVal,this.determineDirectionAndSmartEasing(),this.rAF=requestAnimationFrame(this.count)):cancelAnimationFrame(this.rAF),this.paused=!this.paused},t.prototype.reset=function(){cancelAnimationFrame(this.rAF),this.paused=!0,this.resetDuration(),this.startVal=this.validateValue(this.options.startVal),this.frameVal=this.startVal,this.printValue(this.startVal)},t.prototype.update=function(t){cancelAnimationFrame(this.rAF),this.startTime=null,this.endVal=this.validateValue(t),this.endVal!==this.frameVal&&(this.startVal=this.frameVal,this.finalEndVal||this.resetDuration(),this.finalEndVal=null,this.determineDirectionAndSmartEasing(),this.rAF=requestAnimationFrame(this.count))},t.prototype.printValue=function(t){var i=this.formattingFn(t);"INPUT"===this.el.tagName?this.el.value=i:"text"===this.el.tagName||"tspan"===this.el.tagName?this.el.textContent=i:this.el.innerHTML=i},t.prototype.ensureNumber=function(t){return"number"==typeof t&&!isNaN(t)},t.prototype.validateValue=function(t){var i=Number(t);return this.ensureNumber(i)?i:(this.error="[CountUp] invalid start or end value: ".concat(t),null)},t.prototype.resetDuration=function(){this.startTime=null,this.duration=1e3*Number(this.options.duration),this.remaining=this.duration},t}();

/***/ }),

/***/ 45728:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(58152);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 43738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Config; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8100);
/* harmony import */ var utils_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92233);



function Config(param) {
    var children = param.children, fallback = param.fallback;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swr__WEBPACK_IMPORTED_MODULE_1__/* .SWRConfig */ .J$, {
        value: {
            refreshInterval: 1000 * 60 * 2,
            fetcher: function(q, variables) {
                return (0,utils_query__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(q, variables);
            },
            fallback: fallback
        },
        children: children
    });
};


/***/ }),

/***/ 13693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Card; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./node_modules/@heroicons/react/solid/esm/GlobeAltIcon.js


function GlobeAltIcon(props, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M4.083 9h1.946c.089-1.546.383-2.97.837-4.118A6.004 6.004 0 004.083 9zM10 2a8 8 0 100 16 8 8 0 000-16zm0 2c-.076 0-.232.032-.465.262-.238.234-.497.623-.737 1.182-.389.907-.673 2.142-.766 3.556h3.936c-.093-1.414-.377-2.649-.766-3.556-.24-.56-.5-.948-.737-1.182C10.232 4.032 10.076 4 10 4zm3.971 5c-.089-1.546-.383-2.97-.837-4.118A6.004 6.004 0 0115.917 9h-1.946zm-2.003 2H8.032c.093 1.414.377 2.649.766 3.556.24.56.5.948.737 1.182.233.23.389.262.465.262.076 0 .232-.032.465-.262.238-.234.498-.623.737-1.182.389-.907.673-2.142.766-3.556zm1.166 4.118c.454-1.147.748-2.572.837-4.118h1.946a6.004 6.004 0 01-2.783 4.118zm-6.268 0C6.412 13.97 6.118 12.546 6.03 11H4.083a6.004 6.004 0 002.783 4.118z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = react.forwardRef(GlobeAltIcon);
/* harmony default export */ var esm_GlobeAltIcon = (ForwardRef);
// EXTERNAL MODULE: ./context/app.js
var app = __webpack_require__(40714);
// EXTERNAL MODULE: ./components/global/card.module.css
var card_module = __webpack_require__(49969);
var card_module_default = /*#__PURE__*/__webpack_require__.n(card_module);
;// CONCATENATED MODULE: ./components/global/card.jsx
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

/* eslint-disable @next/next/no-img-element */ 




function Card(_param) {
    var props = _extends({}, _param);
    var link = props.link, image = props.image, title = props.title, type = props.type, additional = props.additional, location = props.location;
    var user = (0,react.useContext)(app/* default */.Z).user;
    // hack
    var isRestroom = title.toLowerCase().includes("restroom");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: link,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            className: "group relative block",
            children: [
                (user === null || user === void 0 ? void 0 : user.CanAccessAdmin) && (location === null || location === void 0 ? void 0 : location.Latitude) && (location === null || location === void 0 ? void 0 : location.Longitude) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "absolute top-0 right-0 z-10 rounded-tr rounded-bl bg-blue-500 p-2",
                    "aria-hidden": "true",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_GlobeAltIcon, {
                        className: "h-4 w-4 fill-white"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    "aria-hidden": "true",
                    className: "aspect-w-16 aspect-h-9 overflow-hidden rounded-lg group-hover:opacity-75",
                    children: image ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "https://images.opencoaster.com/800x400/".concat(image.hash).concat(image.ext),
                        srcSet: "\n                https://images.opencoaster.com/800x400/".concat(image.hash).concat(image.ext, " 800w,\n                https://images.opencoaster.com/600x300/").concat(image.hash).concat(image.ext, " 600w,\n                https://images.opencoaster.com/400x200/").concat(image.hash).concat(image.ext, " 400w,\n                https://images.opencoaster.com/300x150/").concat(image.hash).concat(image.ext, " 300w,\n                https://images.opencoaster.com/200x100/").concat(image.hash).concat(image.ext, " 200w,\n                https://images.opencoaster.com/100x50/").concat(image.hash).concat(image.ext, " 100w\n              "),
                        alt: image.alternativeText ? image.alternativeText : title,
                        className: "h-full w-full object-cover object-center"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "h-full w-full bg-gray-200 object-cover object-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex justify-center ".concat((card_module_default()).contents),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "flex",
                                src: "/placeholder-".concat(isRestroom ? "restroom" : type, ".svg"),
                                alt: title
                            })
                        })
                    })
                }),
                additional && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-3 text-sm text-gray-500",
                    children: additional
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: "text-base font-semibold text-gray-900 ".concat(!additional ? "mt-3" : ""),
                    children: title
                })
            ]
        })
    });
};


/***/ }),

/***/ 84212:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useToggle; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useToggle() {
    var initialValue = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialValue), value = ref[0], setValue = ref[1];
    var toggle = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        setValue(function(v) {
            return !v;
        });
    }, []);
    return [
        value,
        toggle
    ];
};


/***/ }),

/***/ 58152:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./context/app.js
var app = __webpack_require__(40714);
;// CONCATENATED MODULE: ./components/messages/registered.jsx




var Registered = function() {
    var appContext = (0,react.useContext)(app/* default */.Z);
    var unsetMessage = function() {
        if (appContext.flashMessage === "registered") {
            appContext.setFlashMessage(null);
        }
        router_default().events.off("routeChangeComplete", unsetMessage);
    };
    router_default().events.on("routeChangeComplete", unsetMessage);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "m-6 bg-emerald-400 text-gray-900 p-6 container mx-auto",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Welcome! You can now start tracking your ride credits. Use the search below to get going!"
            })
        })
    });
};
/* harmony default export */ var registered = (Registered);

// EXTERNAL MODULE: ./node_modules/react-countup/build/index.js
var build = __webpack_require__(17857);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
;// CONCATENATED MODULE: ./public/placeholder-attraction.svg
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgPlaceholderAttraction = function SvgPlaceholderAttraction(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M40.29 19.53c-.41-2.7-1.47-5.19-3.03-7.3.35-.44.55-.97.55-1.54 0-.67-.26-1.3-.73-1.77-.91-.9-2.33-.96-3.31-.18-2.11-1.56-4.6-2.62-7.3-3.03C26.32 4.47 25.28 3.5 24 3.5s-2.32.97-2.47 2.21c-2.71.41-5.19 1.47-7.3 3.03-.98-.77-2.41-.72-3.31.18-.47.47-.73 1.1-.73 1.77 0 .57.2 1.1.55 1.54-1.56 2.11-2.62 4.6-3.03 7.3-1.24.15-2.21 1.19-2.21 2.47s.97 2.32 2.21 2.47c.41 2.7 1.47 5.19 3.03 7.3-.35.44-.55.97-.55 1.54a2.49 2.49 0 0 0 2.5 2.5c.55 0 1.09-.19 1.54-.55.46.34.95.66 1.44.96L11.7 43.5H9c-.28 0-.5.22-.5.5s.22.5.5.5h30c.28 0 .5-.22.5-.5s-.22-.5-.5-.5h-2.7l-3.97-7.28c.5-.29.98-.61 1.44-.96.45.36.99.55 1.54.55a2.49 2.49 0 0 0 2.5-2.5c0-.57-.2-1.1-.55-1.54 1.56-2.11 2.62-4.6 3.03-7.3 1.24-.15 2.21-1.19 2.21-2.47s-.97-2.32-2.21-2.47zm-15.79-13c3.9.13 7.43 1.69 10.08 4.18l-8.5 8.5c-.46-.34-1-.57-1.59-.66V6.53zm0 18.92c.25-.04.49-.09.71-.18l5.76 10.55c-1.96.99-4.15 1.58-6.47 1.65V25.45zm-1-18.92v12.03c-.59.09-1.13.31-1.59.66l-8.5-8.5A15.33 15.33 0 0 1 23.5 6.53zm0 18.92v12.03c-2.32-.07-4.51-.66-6.47-1.65l5.76-10.55c.22.08.46.13.71.17zM12.71 11.42l8.5 8.5c-.34.46-.57 1-.66 1.59H8.53c.12-3.91 1.68-7.44 4.18-10.09zM8.53 22.5h12.03c.09.59.31 1.13.66 1.59l-8.5 8.5A15.33 15.33 0 0 1 8.53 22.5zm4.89 10.79 8.48-8.48-5.75 10.53c-.99-.58-1.9-1.27-2.73-2.05zM35.16 43.5H12.84l3.71-6.8c1.54.78 3.21 1.32 4.98 1.59.15 1.24 1.19 2.21 2.47 2.21s2.32-.97 2.47-2.21c1.77-.27 3.44-.81 4.98-1.59l3.71 6.8zm-3.31-8.16L26.1 24.81l8.48 8.48c-.83.78-1.74 1.47-2.73 2.05zm3.44-2.76-8.5-8.5c.34-.46.57-1 .66-1.59h12.03c-.13 3.91-1.69 7.44-4.19 10.09zM27.45 21.5c-.09-.59-.31-1.13-.66-1.59l8.5-8.5c2.49 2.66 4.06 6.19 4.18 10.08H27.45z"
  })));
};

/* harmony default export */ var placeholder_attraction = (SvgPlaceholderAttraction);
;// CONCATENATED MODULE: ./public/placeholder-park.svg
var placeholder_park_path, _path2;

function placeholder_park_extends() { placeholder_park_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return placeholder_park_extends.apply(this, arguments); }



var SvgPlaceholderPark = function SvgPlaceholderPark(props) {
  return /*#__PURE__*/react.createElement("svg", placeholder_park_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    xmlSpace: "preserve"
  }, props), placeholder_park_path || (placeholder_park_path = /*#__PURE__*/react.createElement("path", {
    d: "M29.7 66.5h38.5v5.8H29.7zM19 25v-8.5h-.9V25L11 45h15.1zm61.2-.1v-8.2h-1v8.2l-7.1 20h15.1zm-30.8-9.2V5.6h-1v10.2L38.4 38h21z"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M22.9 19.7c4.1.7 7.1-2 7.1-2s-2.3 1.1-5.2-.5c-3-1.6-5.2-.8-5.2-.8v3.4l.9-.1c.8-.1 1.6-.1 2.4 0zM53.2 8.9c4.1.7 7.1-2 7.1-2s-2.2 1.1-5.2-.5-5.2-.8-5.2-.8V9l.9-.1c.8-.2 1.6-.2 2.4 0zm30.8 11c4.1.7 7.1-2 7.1-2s-2.3 1.1-5.2-.5c-3-1.6-5.2-.8-5.2-.8V20l.9-.1c.8-.2 1.6-.2 2.4 0zM29.7 95.3h11.6v-7.2c0-4.2 3.4-7.6 7.6-7.6 4.2 0 7.6 3.4 7.6 7.6v7.2h11.6V74.9H29.7v20.4zm30.7-15.5h4v4h-4v-4zm-27.1 0h4v4h-4v-4zM10.1 59.4h-2v3.4h2v32.5H27V62.9h2v-3.4H10.1zm11.6 16.8h-6.3v-4.6c0-1.7 1.4-3.1 3.1-3.1 1.7 0 3.1 1.4 3.1 3.1v4.6zm2.5-27.6h-2.5v-2.2h-1.9v2.2h-2.5v-2.2h-1.9v2.2h-2.5v-2.2H8.1v3.2H11v7.7h15.1v-7.7H29v-3.2h-4.8zm47.1 10.7h-2v3.4h2v32.5h16.9V62.8h2v-3.4H71.3zm11.6 16.8h-6.3v-4.6c0-1.7 1.4-3.1 3.1-3.1s3.1 1.4 3.1 3.1v4.6zm2.4-27.6h-2.4v-2.2H81v2.2h-2.5v-2.2h-1.9v2.2h-2.5v-2.2h-4.8v3.2h2.9v7.7h15.1v-7.7h2.9v-3.2h-4.9zM38.9 63.8H59V45h3.5v-5.2H60v1.8h-2.5v-1.8H55v1.7h-2.5v-1.7H50v1.8h-2.5v-1.8H45v1.8h-2.5v-1.8H40v1.8h-2.5v-1.8H35V45h3.5v18.8zm6.9-11.9c0-1.7 1.4-3.1 3.1-3.1s3.1 1.4 3.1 3.1v4.6h-6.3v-4.6z"
  })));
};

/* harmony default export */ var placeholder_park = (SvgPlaceholderPark);
;// CONCATENATED MODULE: ./public/placeholder-resort.svg
var _style, placeholder_resort_path, placeholder_resort_path2, _path3;

function placeholder_resort_extends() { placeholder_resort_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return placeholder_resort_extends.apply(this, arguments); }



var SvgPlaceholderResort = function SvgPlaceholderResort(props) {
  return /*#__PURE__*/react.createElement("svg", placeholder_resort_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/react.createElement("style", null, ".placeholder-resort_svg__st0,.placeholder-resort_svg__st1{stroke-linecap:round;stroke-linejoin:round}.placeholder-resort_svg__st0{fill:none;stroke:#000;stroke-width:2;stroke-miterlimit:10}.placeholder-resort_svg__st1{stroke-width:.5}.placeholder-resort_svg__st1,.placeholder-resort_svg__st2,.placeholder-resort_svg__st3,.placeholder-resort_svg__st4,.placeholder-resort_svg__st5{stroke:#000;stroke-miterlimit:10}.placeholder-resort_svg__st2{fill:none;stroke-width:2}.placeholder-resort_svg__st3,.placeholder-resort_svg__st4,.placeholder-resort_svg__st5{stroke-linecap:round;stroke-linejoin:round}.placeholder-resort_svg__st4,.placeholder-resort_svg__st5{fill:none;stroke-width:1.8}.placeholder-resort_svg__st5{stroke-width:1.6}")), placeholder_resort_path || (placeholder_resort_path = /*#__PURE__*/react.createElement("path", {
    d: "M35.8 50.3c-1.9 0-3.4 1.5-3.4 3.4v3.2c0 .6.4 1 1 1h4.8c.6 0 1-.4 1-1v-3.2c0-1.9-1.5-3.4-3.4-3.4zm1.4 5.5h-2.8v-2.2c0-.8.6-1.4 1.4-1.4s1.4.6 1.4 1.4v2.2zm6.2 2h4.8c.6 0 1-.4 1-1v-3.2c0-1.9-1.5-3.4-3.4-3.4s-3.4 1.5-3.4 3.4v3.2c0 .6.5 1 1 1zm1-4.1c0-.8.6-1.4 1.4-1.4.8 0 1.4.6 1.4 1.4v2.2h-2.8v-2.2zm-8.6 7.8c-1.9 0-3.4 1.5-3.4 3.4v3.2c0 .6.4 1 1 1h4.8c.6 0 1-.4 1-1v-3.2c0-1.9-1.5-3.4-3.4-3.4zm1.4 5.6h-2.8v-2.2c0-.8.6-1.4 1.4-1.4s1.4.6 1.4 1.4v2.2zm6.2 2h4.8c.6 0 1-.4 1-1v-3.2c0-1.9-1.5-3.4-3.4-3.4s-3.4 1.5-3.4 3.4v3.2c0 .5.5 1 1 1zm1-4.2c0-.8.6-1.4 1.4-1.4.8 0 1.4.6 1.4 1.4v2.2h-2.8v-2.2zm11.2-14.6c-1.9 0-3.4 1.5-3.4 3.4v3.2c0 .6.4 1 1 1H58c.6 0 1-.4 1-1v-3.2c0-1.9-1.5-3.4-3.4-3.4zm1.4 5.5h-2.8v-2.2c0-.8.6-1.4 1.4-1.4.8 0 1.4.6 1.4 1.4v2.2zM35.8 39.1c-1.9 0-3.4 1.5-3.4 3.4v3.2c0 .6.4 1 1 1h4.8c.6 0 1-.4 1-1v-3.2c0-1.9-1.5-3.4-3.4-3.4zm1.4 5.6h-2.8v-2.2c0-.8.6-1.4 1.4-1.4s1.4.6 1.4 1.4v2.2zm6.2 2h4.8c.6 0 1-.4 1-1v-3.2c0-1.9-1.5-3.4-3.4-3.4s-3.4 1.5-3.4 3.4v3.2c0 .5.5 1 1 1zm1-4.2c0-.8.6-1.4 1.4-1.4.8 0 1.4.6 1.4 1.4v2.2h-2.8v-2.2zm-8.6-14.4c-1.9 0-3.4 1.5-3.4 3.4v3.2c0 .6.4 1 1 1h4.8c.6 0 1-.4 1-1v-3.2c0-1.9-1.5-3.4-3.4-3.4zm1.4 5.6h-2.8v-2.2c0-.8.6-1.4 1.4-1.4s1.4.6 1.4 1.4v2.2zm6.2 2h4.8c.6 0 1-.4 1-1v-3.2c0-1.9-1.5-3.4-3.4-3.4s-3.4 1.5-3.4 3.4v3.2c0 .5.5 1 1 1zm1-4.2c0-.8.6-1.4 1.4-1.4.8 0 1.4.6 1.4 1.4v2.2h-2.8v-2.2zm8.8 4.2H58c.6 0 1-.4 1-1v-3.2c0-1.9-1.5-3.4-3.4-3.4s-3.4 1.5-3.4 3.4v3.2c0 .5.4 1 1 1zm1-4.2c0-.8.6-1.4 1.4-1.4s1.4.6 1.4 1.4v2.2h-2.8v-2.2zm1.4 7.6c-1.9 0-3.4 1.5-3.4 3.4v3.2c0 .6.4 1 1 1H58c.6 0 1-.4 1-1v-3.2c0-1.9-1.5-3.4-3.4-3.4zm1.4 5.6h-2.8v-2.2c0-.8.6-1.4 1.4-1.4.8 0 1.4.6 1.4 1.4v2.2zm-1.4 16.8c-1.9 0-3.4 1.5-3.4 3.4v3.2c0 .6.4 1 1 1H58c.6 0 1-.4 1-1v-3.2c0-1.9-1.5-3.4-3.4-3.4zm1.4 5.6h-2.8v-2.2c0-.8.6-1.4 1.4-1.4.8 0 1.4.6 1.4 1.4v2.2z"
  })), placeholder_resort_path2 || (placeholder_resort_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M89.1 85.2h-4.2V70.4c0-.6.5-1.1 1.1-1.1s1.1.5 1.1 1.1c0 .6.4 1 1 1s1-.4 1-1c0-1.7-1.4-3.1-3.1-3.1-.3 0-.6.1-.8.1.5-1 1.5-1.7 2.6-1.7.6 0 1-.4 1-1s-.4-1-1-1c-1.1 0-2.1.4-2.9 1v-1.3c0-.6-.4-1-1-1s-1 .4-1 1v1.3c-.8-.6-1.8-1-2.9-1-.6 0-1 .4-1 1s.4 1 1 1c1.2 0 2.1.7 2.6 1.7-.3-.1-.5-.1-.8-.1-1.7 0-3.1 1.4-3.1 3.1 0 .6.4 1 1 1s1-.4 1-1 .5-1.1 1.1-1.1c.6 0 1.1.5 1.1 1.1v14.8h-6.4c.1-.1.1-.2.2-.3 4.1-13.7-2.9-20.9-3.2-21.2l-.1-.1c-.1 0-.1-.1-.2-.1h-.8c-.1 0-.2.1-.2.2 0 0-.1 0-.1.1-.3.3-7 7.4-3.1 21.2 0 .1.1.2.2.3h-3.8V16.1c0-.6-.4-1-1-1h-36c-.6 0-1 .4-1 1v69.1h-8.1V63.1c0-1.2 1-2.2 2.2-2.2s2.2 1 2.2 2.2c0 .6.4 1 1 1s1-.4 1-1c0-2.3-1.9-4.2-4.2-4.2-.8 0-1.4.2-2.1.6.5-2.2 2.4-3.8 4.7-3.8.6 0 1-.4 1-1s-.4-1-1-1c-1.9 0-3.6.8-4.8 2v-3c0-.6-.4-1-1-1s-1 .4-1 1v3a6.8 6.8 0 0 0-4.8-2c-.6 0-1 .4-1 1s.4 1 1 1c2.3 0 4.2 1.6 4.7 3.8-.6-.3-1.3-.6-2.1-.6-2.3 0-4.2 1.9-4.2 4.2 0 .6.4 1 1 1s1-.4 1-1c0-1.2 1-2.2 2.2-2.2s2.2 1 2.2 2.2v22.1h-5.5c-.6 0-1 .4-1 1s.4 1 1 1h77.3c.6 0 1-.4 1-1s-.5-1-1-1zm-14.1-2-1.2-.6V67.7c1.5 2.8 3.2 8 1.2 15.5zm-3.2-15.7v15l-1.3.6c-1.8-7.6-.1-12.8 1.3-15.6zm1 16.8 1.8.9H71l1.8-.9zm-9.5-67.2v3.5H29.4v-3.5h33.9zm-33.9 5.5h33.9v62.6H50.8v-6c0-2.8-2.2-5.2-4.9-5.2S41 76.3 41 79.2v6H29.4V22.6zm19.4 62.6h-5.9v-6c0-1.7 1.3-3.2 2.9-3.2 1.6 0 2.9 1.4 2.9 3.2v6zm34.4-60.1c0-2.6-2.1-4.6-4.6-4.6S74 22.6 74 25.1s2.1 4.6 4.6 4.6 4.6-2.1 4.6-4.6zm-4.7 2.6c-1.5 0-2.6-1.2-2.6-2.6s1.2-2.6 2.6-2.6c1.5 0 2.6 1.2 2.6 2.6s-1.1 2.6-2.6 2.6zm1-9.4V16c0-.6-.4-1-1-1s-1 .4-1 1v2.4c0 .6.4 1 1 1s1-.5 1-1.1zm4-2c-.5-.3-1.1-.1-1.4.4l-1.2 2c-.3.5-.1 1.1.4 1.4.2.1.3.1.5.1.3 0 .7-.2.9-.5l1.2-2c.3-.5.1-1.1-.4-1.4zm0 5.8c.2.3.5.5.9.5.2 0 .3 0 .5-.1l2-1.2c.5-.3.6-.9.4-1.4s-.9-.6-1.4-.4l-2 1.2c-.5.3-.7 1-.4 1.4zm.8 2.9c0 .5.5 1 1 1h2.4c.6 0 1-.5 1-1 0-.6-.5-1-1-1h-2.4c-.6 0-1 .4-1 1zm2.2 5.5c.4 0 .7-.2.9-.5.3-.5.1-1.1-.4-1.4l-2.1-1.1c-.5-.3-1.1-.1-1.4.4s-.1 1.1.4 1.4l2.1 1.1c.2 0 .4.1.5.1zm-4 2.9c.2.3.5.5.9.5.2 0 .4 0 .5-.1.5-.3.6-.9.3-1.4l-1.2-2c-.3-.5-.9-.6-1.4-.3-.5.3-.6.9-.3 1.4l1.2 1.9zm-3.8-2.6c-.6 0-1 .5-1 1l.1 2.4c0 .5.5 1 1 1 .6 0 1-.5 1-1l-.1-2.4c0-.5-.4-1-1-1z"
  })), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M73.8 34c.1.1.3.1.5.1.4 0 .7-.2.9-.5l1.1-2.1c.3-.5.1-1.1-.4-1.4-.5-.3-1.1-.1-1.4.4l-1.1 2.1c-.3.6-.1 1.2.4 1.4zm-3-3c.2 0 .4-.1.5-.2l2-1.3c.5-.3.6-.9.3-1.4-.3-.5-.9-.6-1.4-.3l-2 1.3c-.5.3-.6.9-.3 1.4.3.3.6.5.9.5zm-2.4-5.4c0 .5.5 1 1 1h.1l2.3-.1c.6 0 1-.5.9-1 0-.6-.5-1-1-.9l-2.3.1c-.6-.1-1 .3-1 .9zm1.1-5.1c-.2.5-.1 1.1.4 1.3l2.1 1.1c.1.1.3.1.5.1.4 0 .7-.2.9-.5.2-.5.1-1.1-.4-1.3l-2.1-1.1c-.6-.3-1.2-.1-1.4.4zm5.3-.1c.2 0 .4-.1.6-.2.5-.3.6-.9.3-1.4l-1.3-2c-.3-.5-.9-.6-1.4-.3s-.6.9-.3 1.4l1.3 2c.1.4.5.5.8.5z"
  })));
};

/* harmony default export */ var placeholder_resort = (SvgPlaceholderResort);
;// CONCATENATED MODULE: ./public/placeholder-company.svg
var placeholder_company_path;

function placeholder_company_extends() { placeholder_company_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return placeholder_company_extends.apply(this, arguments); }



var SvgPlaceholderCompany = function SvgPlaceholderCompany(props) {
  return /*#__PURE__*/react.createElement("svg", placeholder_company_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    xmlSpace: "preserve"
  }, props), placeholder_company_path || (placeholder_company_path = /*#__PURE__*/react.createElement("path", {
    d: "M2.5 96.6h95v-6h-6V39.9l-33.2-9.1v59.7h-4.5V3.4l-45.3 9v78.2h-6v6zm75.4-48.9h6v7.8h-6v-7.8zm0 13.9h6v7.8h-6v-7.8zm0 13.9h6v7.8h-6v-7.8zM65.8 47.7h6v7.8h-6v-7.8zm0 13.9h6v7.8h-6v-7.8zm0 13.9h6v7.8h-6v-7.8zM40.2 20h6v7.8h-6V20zm0 13.9h6v7.8h-6v-7.8zm0 13.8h6v7.8h-6v-7.8zm0 13.9h6v7.8h-6v-7.8zM28.1 20h6v7.8h-6V20zm0 13.9h6v7.8h-6v-7.8zm0 13.8h6v7.8h-6v-7.8zm0 13.9h6v7.8h-6v-7.8zM16 20h6v7.8h-6V20zm0 13.9h6v7.8h-6v-7.8zm0 13.8h6v7.8h-6v-7.8zm0 13.9h6v7.8h-6v-7.8zm9.4 13.9h11.5v15.1H25.4V75.5z"
  })));
};

/* harmony default export */ var placeholder_company = (SvgPlaceholderCompany);
;// CONCATENATED MODULE: ./public/placeholder-manufacturer.svg
var placeholder_manufacturer_path;

function placeholder_manufacturer_extends() { placeholder_manufacturer_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return placeholder_manufacturer_extends.apply(this, arguments); }



var SvgPlaceholderManufacturer = function SvgPlaceholderManufacturer(props) {
  return /*#__PURE__*/react.createElement("svg", placeholder_manufacturer_extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality"
    },
    viewBox: "0 0 697.52 798.4",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), placeholder_manufacturer_path || (placeholder_manufacturer_path = /*#__PURE__*/react.createElement("path", {
    d: "m185.52 163.55 27-101.65L110.4 163.55h75.12zm38.16-143.71 3.11-11.7c2.87-10.9 18.37-10.78 21.23 0l1.79 6.73L588.7 163.55h55.11c3.29 0 6.24 1.44 8.25 3.73l42.17 41.27c7.04 6.94 1.99 18.78-7.68 18.78l-395.44.02v43.78h133.98c6.07 0 11 4.92 11 10.99v321.96H291.12l.01 183.32c0 6.07-4.92 11-10.99 11h-85.47c-6.07 0-10.99-4.93-10.99-11V227.36H83.83v45.84c0 6.07-4.93 10.99-11 10.99H11c-6.07 0-11-4.92-11-10.99V117.72c0-6.07 4.93-11 11-11h61.83c6.07 0 11 4.93 11 11v41.35L223.68 19.84zM257 41.96l32.29 121.59h244.84L257 41.96zm71.72 421.01h85.38V293.12H291.11l.01 288.97h26.6V462.97h11zm312.14-102.92c-4.16 14.29-12.84 27.85-30.41 32.17-19.01 4.64-6.11 30.18 5.64 29.76 16.94-.62 21.81-15.19 21.82-15.22 4.51-13.65 25.3-6.81 20.78 6.88-.02.08-9.7 29.07-41.83 30.24-37.76 1.38-56.63-61.91-11.64-72.97 5.32-1.31 9.06-4.67 11.69-9.06-42.14-5.39-64.84-51.7-44.54-88.1 2-3.6 5.73-5.63 9.58-5.63l85.02-.05c4.5 0 8.37 2.71 10.08 6.58 17.74 33.15.48 74.89-36.19 85.4z"
  })));
};

/* harmony default export */ var placeholder_manufacturer = (SvgPlaceholderManufacturer);
// EXTERNAL MODULE: ./node_modules/graphql-request/dist/index.js
var graphql_request_dist = __webpack_require__(28687);
;// CONCATENATED MODULE: ./queries/siteStats.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  query SiteStats {\n    attractionsCount\n    companiesCount\n    manufacturersCount\n    parksCount\n    resortsCount\n    rideCreditCount\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var SITE_STATS_QUERY = (0,graphql_request_dist.gql)(_templateObject());
/* harmony default export */ var siteStats = (SITE_STATS_QUERY);

;// CONCATENATED MODULE: ./components/site/stats.jsx













function SiteStats() {
    var user = (0,react.useContext)(app/* default */.Z).user;
    var ref = (0,dist/* default */.ZP)(siteStats), data = ref.data, error = ref.error;
    if (error) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
        className: "mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative overflow-hidden rounded-lg bg-white px-4 pt-5 pb-12 shadow sm:px-6 sm:pt-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("dt", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute rounded-md bg-indigo-500 p-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(placeholder_attraction, {
                                    className: "h-6 w-6 fill-white"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "ml-16 truncate text-sm font-medium text-gray-500",
                                children: "Attractions"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("dd", {
                        className: "ml-16 flex items-baseline pb-6 sm:pb-7",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-2xl font-semibold text-gray-900",
                                children: data === null || data === void 0 ? void 0 : data.attractionsCount
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute inset-x-0 bottom-0 bg-gray-50 px-4 py-4 sm:px-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-sm",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/attractions",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            className: "font-medium text-indigo-600 hover:text-indigo-500",
                                            children: [
                                                "View all",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "sr-only",
                                                    children: " attractions"
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative overflow-hidden rounded-lg bg-white px-4 pt-5 pb-12 shadow sm:px-6 sm:pt-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("dt", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute rounded-md bg-indigo-500 p-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(placeholder_park, {
                                    className: "h-6 w-6 fill-white"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "ml-16 truncate text-sm font-medium text-gray-500",
                                children: "Parks"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("dd", {
                        className: "ml-16 flex items-baseline pb-6 sm:pb-7",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-2xl font-semibold text-gray-900",
                                children: data === null || data === void 0 ? void 0 : data.parksCount
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute inset-x-0 bottom-0 bg-gray-50 px-4 py-4 sm:px-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-sm",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/parks",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            className: "font-medium text-indigo-600 hover:text-indigo-500",
                                            children: [
                                                "View all",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "sr-only",
                                                    children: " parks"
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative overflow-hidden rounded-lg bg-white px-4 pt-5 pb-12 shadow sm:px-6 sm:pt-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("dt", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute rounded-md bg-indigo-500 p-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(placeholder_resort, {
                                    className: "h-6 w-6 fill-white"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "ml-16 truncate text-sm font-medium text-gray-500",
                                children: "Resorts"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("dd", {
                        className: "ml-16 flex items-baseline pb-6 sm:pb-7",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-2xl font-semibold text-gray-900",
                                children: data === null || data === void 0 ? void 0 : data.resortsCount
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute inset-x-0 bottom-0 bg-gray-50 px-4 py-4 sm:px-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-sm",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/resorts",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            className: "font-medium text-indigo-600 hover:text-indigo-500",
                                            children: [
                                                "View all",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "sr-only",
                                                    children: " resorts"
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative overflow-hidden rounded-lg bg-white px-4 pt-5 pb-12 shadow sm:px-6 sm:pt-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("dt", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute rounded-md bg-indigo-500 p-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(placeholder_company, {
                                    className: "h-6 w-6 fill-white"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "ml-16 truncate text-sm font-medium text-gray-500",
                                children: "Companies"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("dd", {
                        className: "ml-16 flex items-baseline pb-6 sm:pb-7",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-2xl font-semibold text-gray-900",
                                children: data === null || data === void 0 ? void 0 : data.companiesCount
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute inset-x-0 bottom-0 bg-gray-50 px-4 py-4 sm:px-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-sm",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/companies",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            className: "font-medium text-indigo-600 hover:text-indigo-500",
                                            children: [
                                                "View all",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "sr-only",
                                                    children: " companies"
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative overflow-hidden rounded-lg bg-white px-4 pt-5 pb-12 shadow sm:px-6 sm:pt-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("dt", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute rounded-md bg-indigo-500 p-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(placeholder_manufacturer, {
                                    className: "h-6 w-6 fill-white"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "ml-16 truncate text-sm font-medium text-gray-500",
                                children: "Manufacturers"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("dd", {
                        className: "ml-16 flex items-baseline pb-6 sm:pb-7",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-2xl font-semibold text-gray-900",
                                children: data === null || data === void 0 ? void 0 : data.manufacturersCount
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute inset-x-0 bottom-0 bg-gray-50 px-4 py-4 sm:px-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-sm",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/manufacturers",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            className: "font-medium text-indigo-600 hover:text-indigo-500",
                                            children: [
                                                "View all",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "sr-only",
                                                    children: " manufacturers"
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative overflow-hidden rounded-lg bg-white px-4 pt-5 pb-12 shadow sm:px-6 sm:pt-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("dt", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute rounded-md bg-indigo-500 p-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(placeholder_attraction, {
                                    className: "h-6 w-6 fill-white"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "ml-16 truncate text-sm font-medium text-gray-500",
                                children: "Ride Credits"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("dd", {
                        className: "ml-16 flex items-baseline pb-6 sm:pb-7",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-2xl font-semibold text-gray-900",
                                children: data === null || data === void 0 ? void 0 : data.rideCreditCount
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute inset-x-0 bottom-0 bg-gray-50 px-4 py-4 sm:px-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-sm",
                                    children: user ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/profile/".concat(user.id),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "font-medium text-indigo-600 hover:text-indigo-500",
                                            children: "View yours"
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/login",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "font-medium text-indigo-600 hover:text-indigo-500",
                                            children: "Login to track"
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/global/card.jsx + 1 modules
var card = __webpack_require__(13693);
// EXTERNAL MODULE: ./queries/fragments/MainPhoto.js
var MainPhoto = __webpack_require__(20519);
// EXTERNAL MODULE: ./queries/fragments/ParkLite.js
var ParkLite = __webpack_require__(82202);
;// CONCATENATED MODULE: ./queries/recent-attractions.js
function recent_attractions_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function recent_attractions_templateObject() {
    var data = recent_attractions_taggedTemplateLiteral([
        "\n  ",
        "\n  ",
        '\n\n  query Attractions {\n    attractions(sort: "updated_at:desc", limit: 12) {\n      Name\n      Slug\n      id\n      Park {\n        ...ParkLite\n      }\n      CoverPhoto {\n        ...MainPhoto\n      }\n      MainPhoto {\n        ...MainPhoto\n      }\n    }\n  }\n'
    ]);
    recent_attractions_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var RECENT_ATTRACTION_QUERY = (0,graphql_request_dist.gql)(recent_attractions_templateObject(), MainPhoto/* default */.Z, ParkLite/* default */.Z);
/* harmony default export */ var recent_attractions = (RECENT_ATTRACTION_QUERY);

;// CONCATENATED MODULE: ./components/attractions/recent.jsx





function RecentAttractions() {
    var ref;
    var ref1 = (0,dist/* default */.ZP)(recent_attractions), data = ref1.data, error = ref1.error;
    if (error) {
        console.error(error);
        return null;
    }
    if (!Array.isArray(data === null || data === void 0 ? void 0 : data.attractions)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mb-12",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "mb-10 grid grid-cols-2 gap-8 md:grid-cols-3 lg:grid-cols-4",
                children: data === null || data === void 0 ? void 0 : (ref = data.attractions) === null || ref === void 0 ? void 0 : ref.map(function(attraction) {
                    if (!attraction.Park) {
                        console.warn("MISSING PARK", attraction);
                        return null;
                    }
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
                            link: "/park/".concat(attraction.Park.Slug, "/").concat(attraction.Slug),
                            title: attraction.Name,
                            image: attraction.MainPhoto,
                            type: "attraction",
                            additional: attraction.Park.Name
                        })
                    }, "recent-attraction-".concat(attraction.id));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-6 flex justify-end text-right text-lg text-gray-500",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/attractions",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            className: "font-medium text-indigo-600 hover:text-indigo-500",
                            children: [
                                "All attractions",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    "aria-hidden": "true",
                                    children: " \u2192"
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./queries/fragments/ParkCard.js
var ParkCard = __webpack_require__(59147);
;// CONCATENATED MODULE: ./queries/recent-parks.js
function recent_parks_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function recent_parks_templateObject() {
    var data = recent_parks_taggedTemplateLiteral([
        "\n  ",
        '\n\n  query Parks {\n    parks(sort: "updated_at:desc", limit: 6) {\n      ...ParkCard\n    }\n  }\n'
    ]);
    recent_parks_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var RECENT_PARKS_QUERY = (0,graphql_request_dist.gql)(recent_parks_templateObject(), ParkCard/* default */.Z);
/* harmony default export */ var recent_parks = (RECENT_PARKS_QUERY);

;// CONCATENATED MODULE: ./components/parks/recent.jsx





function RecentParks() {
    var ref;
    var ref1 = (0,dist/* default */.ZP)(recent_parks), data = ref1.data, error = ref1.error;
    if (error) {
        console.error(error);
    }
    if (!Array.isArray(data === null || data === void 0 ? void 0 : data.parks)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mb-12",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "mb-10 grid grid-cols-2 gap-8 md:grid-cols-3",
                children: data === null || data === void 0 ? void 0 : (ref = data.parks) === null || ref === void 0 ? void 0 : ref.map(function(park) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
                            link: "/park/".concat(park.Slug),
                            title: park.Name,
                            image: park.MainPhoto,
                            type: "park",
                            isTempClosed: park.IsTempClosed
                        })
                    }, "recent-park-".concat(park.id));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-6 flex justify-end text-right text-lg text-gray-500",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/parks",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            className: "font-medium text-indigo-600 hover:text-indigo-500",
                            children: [
                                "All parks",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    "aria-hidden": "true",
                                    children: " \u2192"
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/config.jsx
var config = __webpack_require__(43738);
;// CONCATENATED MODULE: ./components/recommended/recent.jsx




function RecentlyRecommended() {
    var ref = (0,react.useContext)(app/* default */.Z), recommendedRecentPark = ref.recommendedRecentPark, recommendedRecentAttraction = ref.recommendedRecentAttraction, recommendedRecentResort = ref.recommendedRecentResort;
    if (!recommendedRecentPark && !recommendedRecentAttraction && !recommendedRecentResort) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: "mb-8 font-serif text-3xl text-gray-800",
                children: "Recommended"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-12",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    className: "mb-10 grid grid-cols-2 gap-8 md:grid-cols-3",
                    children: [
                        recommendedRecentAttraction && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
                                link: "/park/".concat(recommendedRecentAttraction.Park.Slug, "/").concat(recommendedRecentAttraction.Slug),
                                title: recommendedRecentAttraction.Name,
                                image: recommendedRecentAttraction.MainPhoto,
                                type: "attraction",
                                additional: recommendedRecentAttraction.Park.Name
                            })
                        }),
                        recommendedRecentPark && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
                                link: "/park/".concat(recommendedRecentPark.Slug),
                                title: recommendedRecentPark.Name,
                                image: recommendedRecentPark.MainPhoto,
                                type: "park",
                                isTempClosed: recommendedRecentPark.IsTempClosed
                            })
                        }),
                        recommendedRecentResort && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
                                link: "/resort/".concat(recommendedRecentResort.Slug),
                                title: recommendedRecentResort.Name,
                                image: recommendedRecentResort.MainPhoto,
                                type: "resort"
                            })
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./hooks/useGeolocationWatch.js

function useGeolocationWatch(consentGiven, options) {
    var ref = (0,react.useState)(null), position = ref[0], setPosition = ref[1];
    var ref1 = (0,react.useState)(null), error = ref1[0], setError = ref1[1];
    var ref2 = (0,react.useState)(null), watch = ref2[0], setWatch = ref2[1];
    (0,react.useEffect)(function() {
        if (consentGiven && !watch) {
            setWatch(navigator.geolocation.watchPosition(setPosition, setError, options));
        }
        return function() {
            return navigator.geolocation.clearWatch(watch);
        };
    }, [
        consentGiven,
        options,
        watch
    ]);
    return [
        position,
        error
    ];
};

// EXTERNAL MODULE: ./hooks/useToggle.js
var useToggle = __webpack_require__(84212);
// EXTERNAL MODULE: ./utils/fetcher.js
var fetcher = __webpack_require__(62412);
// EXTERNAL MODULE: ./utils/const.js
var utils_const = __webpack_require__(96519);
// EXTERNAL MODULE: ./utils/units.js
var units = __webpack_require__(55741);
;// CONCATENATED MODULE: ./components/recommended/nearby.jsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}








function RecommendedNearby() {
    var ref9, ref1;
    var ref2 = _slicedToArray((0,useToggle/* default */.Z)(false), 2), consentGiven = ref2[0], toggleConsentGiven = ref2[1];
    var ref3 = _slicedToArray(useGeolocationWatch(consentGiven, {
        maximumAge: 30 * 1000,
        timeout: 20 * 1000,
        enableHighAccuracy: false
    }), 2), position = ref3[0], positionError = ref3[1];
    var ref4 = (0,dist/* default */.ZP)("/api/geo", fetcher/* default */.Z), fallbackGeo = ref4.data;
    var ref5 = (0,dist/* default */.ZP)(function() {
        var ref, ref6, ref7, ref8;
        if (!consentGiven) return false;
        var geo;
        if ((!(position === null || position === void 0 ? void 0 : (ref = position.coords) === null || ref === void 0 ? void 0 : ref.latitude) || !(position === null || position === void 0 ? void 0 : (ref6 = position.coords) === null || ref6 === void 0 ? void 0 : ref6.longitude)) && (!(fallbackGeo === null || fallbackGeo === void 0 ? void 0 : fallbackGeo.latitude) || !(fallbackGeo === null || fallbackGeo === void 0 ? void 0 : fallbackGeo.longitude))) {
            console.log("No location found");
            return false;
        }
        if ((position === null || position === void 0 ? void 0 : (ref7 = position.coords) === null || ref7 === void 0 ? void 0 : ref7.latitude) && (position === null || position === void 0 ? void 0 : (ref8 = position.coords) === null || ref8 === void 0 ? void 0 : ref8.longitude)) {
            geo = {
                latitude: position.coords.latitude,
                longitude: position.coords.longitude
            };
        } else if ((fallbackGeo === null || fallbackGeo === void 0 ? void 0 : fallbackGeo.latitude) && (fallbackGeo === null || fallbackGeo === void 0 ? void 0 : fallbackGeo.longitude)) {
            geo = {
                latitude: fallbackGeo.latitude,
                longitude: fallbackGeo.longitude
            };
        }
        if (!geo) {
            return false;
        }
        return {
            method: "POST",
            url: "".concat(utils_const/* SEARCH_URL */.vA, "/indexes/omnisearch/search"),
            data: {
                filter: "_geoRadius(".concat(geo.latitude, ",").concat(geo.longitude, ", ").concat((0,units/* MetersFromMiles */.i)(100), ")"),
                sort: [
                    "_geoPoint(".concat(geo.latitude, ",").concat(geo.longitude, "):asc")
                ],
                limit: 3
            },
            headers: {
                Authorization: "Bearer ".concat(utils_const/* SEARCH_TOKEN */.wf)
            }
        };
    }, fetcher/* default */.Z), searchResults = ref5.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: "mb-8 font-serif text-3xl text-gray-800",
                children: "Nearby"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-12",
                children: [
                    !consentGiven && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "button",
                                className: "rounded bg-blue-500 py-2 px-4 font-bold text-white hover:bg-blue-700 focus:outline-none focus:ring",
                                onClick: toggleConsentGiven,
                                children: "Show What's Nearby"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "We only use your location to show nearby results and is not stored or linked to your account."
                            })
                        ]
                    }),
                    positionError && positionError.POSITION_UNAVAILABLE !== positionError.code && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "To enable more accurate location you need to click the pages info icon and enable location. This may vary based on your browser."
                    }),
                    searchResults && (searchResults === null || searchResults === void 0 ? void 0 : (ref9 = searchResults.hits) === null || ref9 === void 0 ? void 0 : ref9.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "mb-10 grid grid-cols-2 gap-8 md:grid-cols-3",
                        children: searchResults === null || searchResults === void 0 ? void 0 : searchResults.hits.map(function(hit) {
                            var link = "/".concat(hit.contentType, "/").concat(hit.slug);
                            var additional = "";
                            // Make attraction urls work
                            if (hit.contentType === "attraction") {
                                if (!hit.parentType || !hit.parentSlug) {
                                    return null;
                                }
                                link = "/".concat(hit.parentType, "/").concat(hit.parentSlug, "/").concat(hit.slug);
                                if (hit.parentName) {
                                    additional = hit.parentName;
                                }
                            }
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
                                    link: link,
                                    title: hit.title,
                                    image: hit.photo,
                                    type: hit.contentType,
                                    additional: additional,
                                    isTempClosed: hit.isTempClosed
                                })
                            }, "nearby-".concat(hit.id));
                        })
                    }),
                    (searchResults === null || searchResults === void 0 ? void 0 : (ref1 = searchResults.hits) === null || ref1 === void 0 ? void 0 : ref1.length) === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "We couldn't find anything within 100 miles."
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./pages/index.jsx











var __N_SSG = true;
function Home(param) {
    var fallback = param.fallback;
    var appContext = (0,react.useContext)(app/* default */.Z);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(config/* default */.Z, {
        fallback: fallback,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: "Open Coaster"
                })
            }),
            appContext.flashMessage && appContext.flashMessage === "registered" && /*#__PURE__*/ (0,jsx_runtime.jsx)(registered, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                className: "container m-6 mx-auto px-6 sm:px-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendedNearby, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RecentlyRecommended, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-8",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SiteStats, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "mb-8 font-serif text-3xl text-gray-800",
                        children: "Recently Updated Parks"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RecentParks, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "mb-8 font-serif text-3xl text-gray-800",
                        children: "Recently Updated Attractions"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RecentAttractions, {})
                ]
            })
        ]
    });
};


/***/ }),

/***/ 20519:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28687);
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(graphql_request__WEBPACK_IMPORTED_MODULE_0__);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment MainPhoto on UploadFile {\n    caption\n    alternativeText\n    hash\n    ext\n    width\n    height\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var MainPhoto = (0,graphql_request__WEBPACK_IMPORTED_MODULE_0__.gql)(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (MainPhoto);


/***/ }),

/***/ 59147:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28687);
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(graphql_request__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var queries_fragments_MainPhoto__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20519);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n\n  fragment ParkCard on Parks {\n    id\n    Name\n    Slug\n    CurrentlyOperating\n    IsTempClosed\n    MainPhoto {\n      ...MainPhoto\n    }\n    Location {\n      Latitude\n      Longitude\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var ParkCard = (0,graphql_request__WEBPACK_IMPORTED_MODULE_0__.gql)(_templateObject(), queries_fragments_MainPhoto__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
/* harmony default export */ __webpack_exports__["Z"] = (ParkCard);


/***/ }),

/***/ 82202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28687);
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(graphql_request__WEBPACK_IMPORTED_MODULE_0__);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment ParkLite on Parks {\n    id\n    Name\n    Slug\n    MainPhoto {\n      ...MainPhoto\n    }\n    Resort {\n      id\n      Name\n      Slug\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ParkLite = (0,graphql_request__WEBPACK_IMPORTED_MODULE_0__.gql)(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (ParkLite);


/***/ }),

/***/ 62412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);

var fetcher = function(url) {
    return axios__WEBPACK_IMPORTED_MODULE_0___default()(url).then(function(res) {
        return res.data;
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (fetcher);


/***/ }),

/***/ 92233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ query1; }
/* harmony export */ });
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28687);
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(graphql_request__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var utils_const__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96519);


function query1(query, args) {
    var variables = args;
    var token;
    if (args === null || args === void 0 ? void 0 : args.variables) {
        variables = args.variables;
    }
    if ((args === null || args === void 0 ? void 0 : args.token) && typeof (args === null || args === void 0 ? void 0 : args.token) === "string") {
        token = args.token;
    }
    var client = new graphql_request__WEBPACK_IMPORTED_MODULE_0__.GraphQLClient(utils_const__WEBPACK_IMPORTED_MODULE_1__/* .GRAPH_URL */ .Vd);
    if (token) {
        client.setHeader("authorization", "Bearer ".concat(token));
    }
    return client.request(query, variables);
};


/***/ }),

/***/ 55741:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ MetersFromMiles; }
/* harmony export */ });
var METERS_PER_MILE = 1609.344;
function MetersFromMiles(miles) {
    return METERS_PER_MILE * miles;
}


/***/ }),

/***/ 49969:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contents":"card_contents__EHihQ"};

/***/ }),

/***/ 17857:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var React = __webpack_require__(67294);
var countup_js = __webpack_require__(8273);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/**
 * Silence SSR Warnings.
 * Borrowed from Formik v2.1.1, Licensed MIT.
 *
 * https://github.com/formium/formik/blob/9316a864478f8fcd4fa99a0735b1d37afdf507dc/LICENSE
 */

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? React.useLayoutEffect : React.useEffect;

/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Create a stable reference to a callback which is updated after each render is committed.
 * Typed version borrowed from Formik v2.2.1. Licensed MIT.
 *
 * https://github.com/formium/formik/blob/9316a864478f8fcd4fa99a0735b1d37afdf507dc/LICENSE
 */

function useEventCallback(fn) {
  var ref = React.useRef(fn); // we copy a ref to the callback scoped to the current state/props on each render

  useIsomorphicLayoutEffect(function () {
    ref.current = fn;
  });
  return React.useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return ref.current.apply(void 0, args);
  }, []);
}

var createCountUpInstance = function createCountUpInstance(el, props) {
  var decimal = props.decimal,
      decimals = props.decimals,
      duration = props.duration,
      easingFn = props.easingFn,
      end = props.end,
      formattingFn = props.formattingFn,
      numerals = props.numerals,
      prefix = props.prefix,
      separator = props.separator,
      start = props.start,
      suffix = props.suffix,
      useEasing = props.useEasing,
      enableScrollSpy = props.enableScrollSpy,
      scrollSpyDelay = props.scrollSpyDelay;
  return new countup_js.CountUp(el, end, {
    startVal: start,
    duration: duration,
    decimal: decimal,
    decimalPlaces: decimals,
    easingFn: easingFn,
    formattingFn: formattingFn,
    numerals: numerals,
    separator: separator,
    prefix: prefix,
    suffix: suffix,
    useEasing: useEasing,
    useGrouping: !!separator,
    enableScrollSpy: enableScrollSpy,
    scrollSpyDelay: scrollSpyDelay
  });
};

var _excluded$1 = ["ref", "startOnMount", "enableReinitialize", "delay", "onEnd", "onStart", "onPauseResume", "onReset", "onUpdate"];
var DEFAULTS = {
  decimal: '.',
  delay: null,
  prefix: '',
  suffix: '',
  duration: 2,
  start: 0,
  startOnMount: true,
  enableReinitialize: true
};

var useCountUp = function useCountUp(props) {
  var _useMemo = React.useMemo(function () {
    return _objectSpread2(_objectSpread2({}, DEFAULTS), props);
  }, [props]),
      ref = _useMemo.ref,
      startOnMount = _useMemo.startOnMount,
      enableReinitialize = _useMemo.enableReinitialize,
      delay = _useMemo.delay,
      onEnd = _useMemo.onEnd,
      onStart = _useMemo.onStart,
      onPauseResume = _useMemo.onPauseResume,
      onReset = _useMemo.onReset,
      onUpdate = _useMemo.onUpdate,
      instanceProps = _objectWithoutProperties(_useMemo, _excluded$1);

  var countUpRef = React.useRef();
  var timerRef = React.useRef();
  var isInitializedRef = React.useRef(false);
  var createInstance = useEventCallback(function () {
    return createCountUpInstance(typeof ref === 'string' ? ref : ref.current, instanceProps);
  });
  var getCountUp = useEventCallback(function (recreate) {
    var countUp = countUpRef.current;

    if (countUp && !recreate) {
      return countUp;
    }

    var newCountUp = createInstance();
    countUpRef.current = newCountUp;
    return newCountUp;
  });
  var start = useEventCallback(function () {
    var run = function run() {
      return getCountUp(true).start(function () {
        onEnd === null || onEnd === void 0 ? void 0 : onEnd({
          pauseResume: pauseResume,
          reset: reset,
          start: restart,
          update: update
        });
      });
    };

    if (delay && delay > 0) {
      timerRef.current = setTimeout(run, delay * 1000);
    } else {
      run();
    }

    onStart === null || onStart === void 0 ? void 0 : onStart({
      pauseResume: pauseResume,
      reset: reset,
      update: update
    });
  });
  var pauseResume = useEventCallback(function () {
    getCountUp().pauseResume();
    onPauseResume === null || onPauseResume === void 0 ? void 0 : onPauseResume({
      reset: reset,
      start: restart,
      update: update
    });
  });
  var reset = useEventCallback(function () {
    timerRef.current && clearTimeout(timerRef.current);
    getCountUp().reset();
    onReset === null || onReset === void 0 ? void 0 : onReset({
      pauseResume: pauseResume,
      start: restart,
      update: update
    });
  });
  var update = useEventCallback(function (newEnd) {
    getCountUp().update(newEnd);
    onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate({
      pauseResume: pauseResume,
      reset: reset,
      start: restart
    });
  });
  var restart = useEventCallback(function () {
    reset();
    start();
  });
  var maybeInitialize = useEventCallback(function (shouldReset) {
    if (startOnMount) {
      if (shouldReset) {
        reset();
      }

      start();
    }
  });
  React.useEffect(function () {
    if (!isInitializedRef.current) {
      isInitializedRef.current = true;
      maybeInitialize();
    } else if (enableReinitialize) {
      maybeInitialize(true);
    }
  }, [enableReinitialize, isInitializedRef, maybeInitialize, delay, props.start, props.suffix, props.prefix, props.duration, props.separator, props.decimals, props.decimal, props.formattingFn]);
  React.useEffect(function () {
    return function () {
      reset();
    };
  }, [reset]);
  return {
    start: restart,
    pauseResume: pauseResume,
    reset: reset,
    update: update,
    getCountUp: getCountUp
  };
};

var _excluded = ["className", "redraw", "containerProps", "children", "style"];

var CountUp = function CountUp(props) {
  var className = props.className,
      redraw = props.redraw,
      containerProps = props.containerProps,
      children = props.children,
      style = props.style,
      useCountUpProps = _objectWithoutProperties(props, _excluded);

  var containerRef = React__default["default"].useRef(null);
  var isInitializedRef = React__default["default"].useRef(false);

  var _useCountUp = useCountUp(_objectSpread2(_objectSpread2({}, useCountUpProps), {}, {
    ref: containerRef,
    startOnMount: typeof children !== 'function' || props.delay === 0,
    // component manually restarts
    enableReinitialize: false
  })),
      start = _useCountUp.start,
      reset = _useCountUp.reset,
      updateCountUp = _useCountUp.update,
      pauseResume = _useCountUp.pauseResume,
      getCountUp = _useCountUp.getCountUp;

  var restart = useEventCallback(function () {
    start();
  });
  var update = useEventCallback(function (end) {
    if (!props.preserveValue) {
      reset();
    }

    updateCountUp(end);
  });
  var initializeOnMount = useEventCallback(function () {
    if (typeof props.children === 'function') {
      // Warn when user didn't use containerRef at all
      if (!(containerRef.current instanceof Element)) {
        console.error("Couldn't find attached element to hook the CountUp instance into! Try to attach \"containerRef\" from the render prop to a an Element, eg. <span ref={containerRef} />.");
        return;
      }
    } // unlike the hook, the CountUp component initializes on mount


    getCountUp();
  });
  React.useEffect(function () {
    initializeOnMount();
  }, [initializeOnMount]);
  React.useEffect(function () {
    if (isInitializedRef.current) {
      update(props.end);
    }
  }, [props.end, update]);
  var redrawDependencies = redraw && props; // if props.redraw, call this effect on every props change

  React.useEffect(function () {
    if (redraw && isInitializedRef.current) {
      restart();
    }
  }, [restart, redraw, redrawDependencies]); // if not props.redraw, call this effect only when certain props are changed

  React.useEffect(function () {
    if (!redraw && isInitializedRef.current) {
      restart();
    }
  }, [restart, redraw, props.start, props.suffix, props.prefix, props.duration, props.separator, props.decimals, props.decimal, props.className, props.formattingFn]);
  React.useEffect(function () {
    isInitializedRef.current = true;
  }, []);

  if (typeof children === 'function') {
    // TypeScript forces functional components to return JSX.Element | null.
    return children({
      countUpRef: containerRef,
      start: start,
      reset: reset,
      update: updateCountUp,
      pauseResume: pauseResume,
      getCountUp: getCountUp
    });
  }

  return /*#__PURE__*/React__default["default"].createElement("span", _extends({
    className: className,
    ref: containerRef,
    style: style
  }, containerProps), props.start ? getCountUp().formattingFn(props.start) : '');
};

__webpack_unused_export__ = CountUp;
__webpack_unused_export__ = useCountUp;


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [533,774,888,179], function() { return __webpack_exec__(45728); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);